import { NextRouter } from 'next/router'

export const updateArrayQueryParams = (
  router: NextRouter,
  param: string,
  value: string[]
) => {
  router.push(
    {
      pathname: router.pathname,
      query: {
        ...router.query,
        [param]: value,
      },
    },
    undefined,
    { shallow: true }
  )
}

export const updateQueryParams = (
  router: NextRouter,
  param: string,
  value: string
) => {
  router.push(
    {
      pathname: router.pathname,
      query: {
        ...router.query,
        [param]: value,
      },
    },
    undefined,
    { shallow: true }
  )
}

export const clearQueryParams = (router: NextRouter) => {
  router.push(
    {
      pathname: router.pathname,
      query: {},
    },
    undefined,
    { shallow: true }
  )
}
